import * as React from "react";
import { inject,observer } from 'mobx-react';
import ModelStore from 'src/stores/ModelStore';
import './NavigationComponent.scss';
interface IState {
    express: boolean
}

interface IProps {
  modelStore?: ModelStore;
}
@inject("modelStore")
@observer
export default class ServiceListComponent extends React.Component<IProps,IState> {

  constructor (props?: any , state?:any){
      super (props, state);
      this.state={ express: false }
      this.select = this.select.bind(this);
  }  

  public render() {
    const styles={
        cursor : "pointer",
        marginTop: "3rem"
       
    }
      return (
        <div className="service-list">
          <h2>Services</h2>
          <ul>
            { this._renderItems()}  
            <li style={styles} onClick={this.select} className="selectable"><span className={ "check-box" + (this.state.express ? " checked": "")} /><span className="label">Expressproduktion</span></li>
          </ul>  
        </div>
    );
    
  }
  public componentDidMount(){
      const modelStore = this.props.modelStore as ModelStore;
      if(modelStore.selectedExpressMethod === "ja"){
        this.setState({express: true });
      };
  }
  private select() {
      
      const modelStore = this.props.modelStore as ModelStore;
      if(! this.state.express ){
        modelStore.selectedExpressMethod = "ja";
      }else{
        modelStore.selectedExpressMethod = "nein";
      }
      this.setState({express: ! this.state.express });
  }
  private _selectModel (model:any){
    const modelStore = this.props.modelStore as ModelStore;
    modelStore.setSelectedService(model); 
    
  }

  private _renderItems():React.ReactNode[]{
      // --> Texte jetzt in ModelStore.js
      const modelStore = this.props.modelStore as ModelStore;
      const items: any[] = [];
      modelStore.services.map( 
        (model: any , index: number )=>{
        items.push(<li key={'item-' + index }><span className="check-box checked"/><span className="label">{ model.title }</span><span className="info" onClick={ this._selectModel.bind(this, model) }/></li>);
      }); 
      return items;
  }

}



// WEBPACK FOOTER //
// ./src/components/ServiceListComponent.tsx